"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.USA_DEMOGRAPHICS = exports.PERSONAL_GROSS_INCOME = exports.GEO = exports.FOOD_PRODUCTS_PURCHASE_QUESTION = exports.RACE_ETHNICITY = void 0;
var types_1 = require("../../types");
var question_1 = require("../../utils/question");
var types_2 = require("../types");
var common_1 = require("./common");
var RACE_ETHNICITY = function (t, languages, settings) {
    var value = types_2.DYNATA_QVALUE.RACE_ETHNICITY_US;
    var translateKey = types_2.DYNATA_TRANSLATION_KEYS[value];
    var options = [
        { label: 'African American / Black', value: '2' },
        { label: 'Asian / Asian American', value: '3' },
        { label: 'Caucasian / White', value: '1' },
        { label: 'Hispanic', value: '8' },
        { label: 'Native American/ Inuit or Aleut', value: '4' },
        { label: 'Native Hawaiian/ Pacific Islander', value: '5' },
        { label: 'Other', value: '6' },
        { label: 'Prefer not to answer', value: '7' }
    ];
    return __assign(__assign({}, (0, common_1.getDefaultQuestion)(t, languages, translateKey, 'Race Ethnicity', value, t && !!(settings === null || settings === void 0 ? void 0 : settings.questionTexts))), { options: (0, question_1.getBuiltInOptions)(languages, options, t, translateKey, settings === null || settings === void 0 ? void 0 : settings.options, settings === null || settings === void 0 ? void 0 : settings.questionId) });
};
exports.RACE_ETHNICITY = RACE_ETHNICITY;
var FOOD_PRODUCTS_PURCHASE_QUESTION = function (t, languages, settings) {
    var value = types_2.DYNATA_QVALUE.FOOD_PRODUCT_PURCHASE;
    var translateKey = types_2.DYNATA_TRANSLATION_KEYS[value];
    var options = [
        {
            label: 'Frozen dinners',
            value: '1'
        },
        {
            label: 'Ice cream',
            value: '2'
        },
        {
            label: 'Cereal (dry, ready to eat)',
            value: '3'
        },
        {
            label: 'Cookies / Crackers',
            value: '4'
        },
        {
            label: 'Cheese',
            value: '5'
        },
        {
            label: 'Salty snacks (chips and pretzels)',
            value: '6'
        },
        {
            label: 'Produce',
            value: '7'
        },
        {
            label: 'Fresh Meat',
            value: '8'
        }
    ];
    return __assign(__assign({}, (0, common_1.getDefaultMultipleChoiceQuestion)(t, languages, translateKey, 'Food Products Purchased P3M', value, options.length, t && !!(settings === null || settings === void 0 ? void 0 : settings.questionTexts))), { options: (0, question_1.getBuiltInOptions)(languages, options, t, translateKey, settings === null || settings === void 0 ? void 0 : settings.options, settings === null || settings === void 0 ? void 0 : settings.questionId) });
};
exports.FOOD_PRODUCTS_PURCHASE_QUESTION = FOOD_PRODUCTS_PURCHASE_QUESTION;
var GEO = function (t, languages, settings) {
    var value = types_2.DYNATA_QVALUE.GEO_US;
    var translateKey = types_2.DYNATA_TRANSLATION_KEYS[value];
    return __assign(__assign({}, (0, common_1.getDefaultQuestion)(t, languages, translateKey, 'GEO - US State', value, t && !!(settings === null || settings === void 0 ? void 0 : settings.questionTexts), { geo: 'state' }, types_1.QTYPES.VECTOR_MAP)), { selectedRegion: {
            id: 'us_aea',
            identifier: 'US',
            label: 'USA',
            title: 'USA',
            value: 'us_aea'
        } });
};
exports.GEO = GEO;
var PERSONAL_GROSS_INCOME = function (t, languages, settings) {
    var value = types_2.DYNATA_QVALUE.PERSONAL_GROSS_INCOME;
    var translateKey = types_2.DYNATA_TRANSLATION_KEYS[value];
    var options = [
        { label: 'Less than $20,000', value: '64' },
        { label: '$20,000 - $29,999', value: '65' },
        { label: '$30,000 - $39,999', value: '66' },
        { label: '$40,000 - $49,999', value: '67' },
        { label: '$50,000 - $59,999', value: '68' },
        { label: '$60,000 - $74,999', value: '69' },
        { label: '$75,000 - $99,999', value: '70' },
        { label: '$100,000 - $149,999', value: '71' },
        { label: '$150,000 +', value: '72' },
        { label: 'Prefer not to answer', value: '237' }
    ];
    return __assign(__assign({}, (0, common_1.getDefaultQuestion)(t, languages, translateKey, 'Gross Income - Personal ANNUAL', value, t && !!(settings === null || settings === void 0 ? void 0 : settings.questionTexts))), { options: (0, question_1.getBuiltInOptions)(languages, options, t, translateKey, settings === null || settings === void 0 ? void 0 : settings.options, settings === null || settings === void 0 ? void 0 : settings.questionId) });
};
exports.PERSONAL_GROSS_INCOME = PERSONAL_GROSS_INCOME;
var USA_DEMOGRAPHICS = function (t, languages, settings) { return [
    (0, common_1.GENDER)(t, languages, types_2.SUPPORTED_COUNTRY_ISO.US, settings),
    (0, common_1.HHR)(t, languages, types_2.SUPPORTED_COUNTRY_ISO.US, settings),
    (0, common_1.AGE)(t, languages, types_2.SUPPORTED_COUNTRY_ISO.US, settings),
    (0, exports.RACE_ETHNICITY)(t, languages, settings),
    (0, common_1.PERSONAL_CARE_PRODUCTS)(t, languages, types_2.SUPPORTED_COUNTRY_ISO.US, settings),
    (0, common_1.FINANCIAL_INSURANCE_PRODUCT)(t, languages, types_2.SUPPORTED_COUNTRY_ISO.US, settings),
    (0, common_1.FINANCIAL_SERVICES)(t, languages, types_2.SUPPORTED_COUNTRY_ISO.US, settings),
    (0, exports.FOOD_PRODUCTS_PURCHASE_QUESTION)(t, languages, settings),
    (0, common_1.LANGUAGE_FLUENCY)(t, languages, types_2.SUPPORTED_COUNTRY_ISO.US, settings),
    (0, common_1.FINANCIAL_PRODUCT)(t, languages, types_2.SUPPORTED_COUNTRY_ISO.US, settings),
    (0, exports.GEO)(t, languages, settings),
    (0, common_1.HOUSEHOLD_CHILDREN)(t, languages, types_2.SUPPORTED_COUNTRY_ISO.US, settings),
    (0, common_1.VEHICLES_IN_HOUSEHOLD)(t, languages, types_2.SUPPORTED_COUNTRY_ISO.US, settings),
    (0, common_1.HOUSEHOLD_APPLICANCE_OWNED)(t, languages, types_2.SUPPORTED_COUNTRY_ISO.US, settings),
    (0, common_1.EMPLOYMENT_STATUS)(t, languages, types_2.SUPPORTED_COUNTRY_ISO.US, settings),
    (0, common_1.PETS_IN_HOUSEHOLD)(t, languages, types_2.SUPPORTED_COUNTRY_ISO.US, settings),
    (0, common_1.NUMBER_OF_CHILDREN)(t, languages, types_2.SUPPORTED_COUNTRY_ISO.US, settings),
    (0, common_1.NON_ALCOHOLIC_BEVERAGES)(t, languages, types_2.SUPPORTED_COUNTRY_ISO.US, settings),
    (0, common_1.PRIMARY_VEHICLES)(t, languages, types_2.SUPPORTED_COUNTRY_ISO.US, settings),
    (0, common_1.HOME_TYPE)(t, languages, types_2.SUPPORTED_COUNTRY_ISO.US, settings),
    (0, common_1.SEXUAL_ORIENTATION)(t, languages, types_2.SUPPORTED_COUNTRY_ISO.US, settings),
    (0, common_1.NUMBER_PPL_IN_HOUSEHOLD)(t, languages, types_2.SUPPORTED_COUNTRY_ISO.US, settings),
    (0, exports.PERSONAL_GROSS_INCOME)(t, languages, settings),
    (0, common_1.HOUSEHOLD_GROSS_INCOME)(t, languages, types_2.SUPPORTED_COUNTRY_ISO.US, settings),
    (0, common_1.MARTIAL_STATUS)(t, languages, types_2.SUPPORTED_COUNTRY_ISO.US, settings),
    (0, common_1.HOUSEHOLD_INVESTABLE_ASSETS)(t, languages, types_2.SUPPORTED_COUNTRY_ISO.US, settings),
    (0, common_1.EDUCATION)(t, languages, types_2.SUPPORTED_COUNTRY_ISO.US, settings)
]; };
exports.USA_DEMOGRAPHICS = USA_DEMOGRAPHICS;
//# sourceMappingURL=US.js.map